export default {
  state: {
    mapTypeId: 'roadmap',
  	redirectedFromMap: false,
  },
  actions: {
    toggleMapType({ commit, state }) {
      commit('setMapType', state.mapTypeId === 'roadmap' ? 'hybrid' : 'roadmap');
    },
  },
  mutations: {
    setMapType(state, payload) {
      state.mapTypeId = payload;
    },
  	redirectFromMap(state){
    	state.redirectedFromMap = true;
	}
  }
};
